import React from "react";
import {BusyState} from "../../components/BusyFromPromise/BusyFromPromise";
import {DataBaseComponent, DataBaseComponentState, Errors} from "../../components/DataBaseComponent";
import SaveDialogLayout from "../../components/DialogLayout/SaveDialogLayout";
import {Select} from "../../components/form";
import {Text} from "components/form";
import repository from "../../client/repository";
import {BackgroundTaskResource} from "../../client/resources/backgroundTaskResource";
import {
    BackgroundTaskSubscriptionRequest,
    BackgroundTaskSubscriptionChannels,
    BackgroundTaskSubscriptionEvents,
} from "../../client/resources/backgroundTaskSubscriptionResource";
import {Item as SelectItem} from "../../components/form/Select/Select";

interface ManageSubscriptionDialogProps {
    errors: Errors;
    busy: BusyState;
    task: BackgroundTaskResource;
    onSaveClick(subscription: BackgroundTaskSubscriptionRequest): Promise<boolean>;
}

interface ManageSubscriptionDialogState extends DataBaseComponentState {
    updateSubscriptionRequest: BackgroundTaskSubscriptionRequest;
}

export class ManageSubscriptionDialog extends DataBaseComponent<ManageSubscriptionDialogProps, ManageSubscriptionDialogState> {
    constructor(props: ManageSubscriptionDialogProps) {
        super(props);
        this.state = {
            updateSubscriptionRequest: {
                SubscriptionEvents: BackgroundTaskSubscriptionEvents.None,
                SubscriptionChannel: BackgroundTaskSubscriptionChannels.Slack,
            }
        };
    }

    async componentDidMount() {
        return await this.doBusyTask(async () => {
            const response = await repository.BackgroundTasks.getSubscription(this.props.task.Id);
            if (response) {
                this.setState({ updateSubscriptionRequest: response })
            }
        });
    }

    render() {
        const eventsOptions: SelectItem[] = [
            {
                value: BackgroundTaskSubscriptionEvents.None,
                text: "None - Unsubscribe from updates"
            },
            {
                value: BackgroundTaskSubscriptionEvents.BackgroundTaskFailed,
                text: "Notify if the task fails"
            },
            {
                value: BackgroundTaskSubscriptionEvents.BackgroundTaskStopped,
                text: "Notify when the task completes or fails"
            },
            {
                value: BackgroundTaskSubscriptionEvents.BackgroundTaskStepCompleted,
                text: "Notify whenever a step completes"
            },
        ];
        const channelOptions: SelectItem[] = [
            {
                value: BackgroundTaskSubscriptionChannels.Slack,
                text: "Slack"
            },
        ];

        const request = this.state.updateSubscriptionRequest;

        return <SaveDialogLayout title={"Manage subscription for this task"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 saveButtonLabel={"Save"}
                                 cancelButtonLabel={"Cancel"}
                                 onSaveClick={() => this.updateSubscription(request)}>

            <Select value={this.state.updateSubscriptionRequest.SubscriptionEvents}
                    onChange={value => this.updateSubscriptionRequest({SubscriptionEvents: value as BackgroundTaskSubscriptionEvents})}
                    items={eventsOptions}
                    fieldName="events"
            />

            <Select value={this.state.updateSubscriptionRequest.SubscriptionChannel}
                    onChange={value => this.updateSubscriptionRequest({SubscriptionChannel: value as BackgroundTaskSubscriptionChannels})}
                    items={channelOptions}
                    fieldName="delivery method"
            />

        </SaveDialogLayout>;
    }

    private updateSubscriptionRequest(update: Partial<BackgroundTaskSubscriptionRequest>) {
        return this.setState(prevState => ({updateSubscriptionRequest: {...prevState.updateSubscriptionRequest, ...update}}));
    }

    private updateSubscription(request: Partial<BackgroundTaskSubscriptionRequest>) {
        return this.doBusyTask(async () => {
            const subscription = await repository.BackgroundTasks.subscribe(this.props.task.Id, request as BackgroundTaskSubscriptionRequest);
            await this.props.onSaveClick(subscription);
            return true;
        })
    }
}
